import PropTypes from 'prop-types';
import React from 'react';
import { components } from 'react-select';
import TopicShape from '../propTypes/TopicShape';
import TopicNameWithIcon from './TopicNameWithIcon';

const { SingleValue } = components;

const propTypes = {
  data: PropTypes.shape({
    topic: TopicShape,
  }).isRequired,
};

const TopicSelectValue = (props) => (
  <SingleValue {...props}>
    <TopicNameWithIcon topic={props.data.topic} />
  </SingleValue>
);

TopicSelectValue.propTypes = propTypes;

export default TopicSelectValue;
